import { render, staticRenderFns } from "./AppUpdateNotification.vue?vue&type=template&id=0640cabe&scoped=true"
import script from "./AppUpdateNotification.vue?vue&type=script&lang=js"
export * from "./AppUpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./AppUpdateNotification.vue?vue&type=style&index=0&id=0640cabe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640cabe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0640cabe')) {
      api.createRecord('0640cabe', component.options)
    } else {
      api.reload('0640cabe', component.options)
    }
    module.hot.accept("./AppUpdateNotification.vue?vue&type=template&id=0640cabe&scoped=true", function () {
      api.rerender('0640cabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AppUpdateNotification.vue"
export default component.exports